import * as React from 'react';
import * as styles from './SiteListRadioDropDown.css';
import ContentOrganizerService from '../../services/ContentOrganizerService';
import { LocalizationService } from "../../services/LocalizationService";
import UserService from '../../services/UserService';

export interface ISiteListRadioDropDownProps {
  placeholder?: string;
  label?: string;
  styles?: any;
  themeColor?: string;
  onSelectOptions(option: any): void;
  singleOption?: boolean;
  environment: "Development" | "Test" | "Production";
  tenant: string;
  token: string;
  selectedValue?: IMultiSelectDropDownOption;
}

export interface ISiteListRadioDropDownState {
  checked: IMultiSelectDropDownOption[];
  dropDownValue: IMultiSelectDropDownOption[];
  take: number;
  skip: number;
  searchQuery: string;
  more: number;
  totalItems: number;
  siteWithoutRequiredPermissions: IMultiSelectDropDownOption;
}

export interface IMultiSelectDropDownOption {
  key: any;
  text: string;
  selected: boolean;
  item: any;
}

export class IASiteListRadioDropDown extends React.Component<ISiteListRadioDropDownProps, ISiteListRadioDropDownState> {
  constructor(props) {
    super(props);
    this.state = {
      checked: this.props.selectedValue ? [this.props.selectedValue] : [],
      dropDownValue: [],
      take: 10,
      skip: 0,
      searchQuery: "",
      more: 1,
      totalItems: 0,
      siteWithoutRequiredPermissions: undefined
    }
    this.fetchData();
  }

  public componentDidMount() {
    this.setState({
      checked: this.props.selectedValue ? [this.props.selectedValue] : [],
    });
  }

  public removeSelectedItem(value) {
    this.checkBox(value, false);
  }

  public fetchData(showMore?: boolean) {
    let more = this.state.more;
    if (showMore) {
      more++;
    }
    ContentOrganizerService.getSites(this.props.tenant, this.props.token, this.props.environment, this.state.searchQuery, (this.state.take * more), this.state.skip).then((searchResult) => {
      const totalItems = searchResult.totalItems;
      const sites = searchResult.items;
      let list = [];
      sites.forEach(site => {
        const tokens = site.path.split("/");
        const sitePath = tokens[tokens.length - 1];
        const title = `${site.title} - (/sites/${sitePath})`
        list.push({ key: sitePath, text: title, selected: false, item: site });
      });
      this.setState({ dropDownValue: list, more, totalItems });
    });
  }

  public async checkBox(value, condition) {
    let checkedValue = this.state.checked;
    let options = this.state.dropDownValue;
    let selected = options.filter(x => x.key === value)[0];

    if (condition) {
      // Check if user has access to site
      const isSiteOwner = await UserService.isSiteOwner(this.props.environment, this.props.tenant, this.props.token, value);
      if (isSiteOwner == false) {
        this.setState({ siteWithoutRequiredPermissions: selected });
        return;
      } else {
        this.setState({ siteWithoutRequiredPermissions: undefined });
      }
    }

    if (!this.props.singleOption) {
      if (condition) {
        selected.selected = true;
        checkedValue.push(selected);
      } else {
        let index = checkedValue.indexOf(value);
        checkedValue.splice(index, 1);
        selected.selected = false;
      }
    } else {
      checkedValue = [];
      options.forEach(item => {
        item.selected = false;
      });
      if (condition) {
        selected.selected = true;
        checkedValue.push(selected);
      } else {
        selected.selected = false;
      }
    }
    this.setState({
      checked: checkedValue
    }, () => {
      this.props.onSelectOptions(options);
    });
  }

  public search(e) {
    if (e.target.value.length !== 0) {
      let enteredValue = e.target.value.toLowerCase();
      let presentValue = this.state.dropDownValue.filter(function (data) {
        return data.text.toLocaleLowerCase().indexOf(enteredValue) > -1;
      })
      this.setState({ dropDownValue: presentValue, searchQuery: enteredValue, more: 1 }, this.fetchData);
    } else {
      this.setState({ dropDownValue: this.state.dropDownValue, searchQuery: "", more: 1 }, this.fetchData);
    }
  }

  public returnSelectedItems() {
    const selectedItem = this.state.checked ? this.state.checked.map((data, index) =>
      <div className={styles["selectedItem-body"]} style={{ backgroundColor: !!this.props.themeColor ? this.props.themeColor : "rgb(35, 135, 155);" }} key={index}>
        <p className={styles["selectedItem-text"]}>{data.text}</p>
        <button className={styles["selectedItem-close"]} onClick={() => this.removeSelectedItem(data.key)}>&times;</button>
      </div>
    ) : [];
    return selectedItem;
  }

  public returnList() {
    const list = this.state.dropDownValue ? this.state.dropDownValue.map((data, index) =>
      <label className={styles.container} key={index}>{data.text}
        <input type="checkbox" value={data.key} onChange={e => this.checkBox(e.target.value, e.target.checked)} checked={this.state.checked.filter(x => x.key === data.key)[0] ? true : false} />
        <span className={styles.checkmark} style={this.state.checked.filter(x => x.key === data.key)[0] ? { backgroundColor: this.props.themeColor, borderColor: this.props.themeColor } : { borderColor: this.props.themeColor }}></span>
      </label>
    ) : null;
    if (list && list.length > 0 && list.length < this.state.totalItems) {
      list.push(
        <label className={styles.container} key={"more"} onClick={() => this.fetchData(true)} style={{ textAlign: "center", color: "rgb(204,204,204)" }}>{new LocalizationService().strings.ContentOrganizer_showMore}</label>
      );
    }

    return list;
  }

  public render() {
    return (
      <div className={styles.multiSelect} style={this.props.styles}>
        {!!this.props.label &&
          <label className={styles["label-text"]}>{this.props.label}</label>
        }
        <input ref={input => input && input.focus()} type="text" name="Search" placeholder={this.props.placeholder} className={styles["input-box"]} onChange={e => this.search(e)} />
        <div className={styles["search-result"]}>
          <div className={styles["list-result"]}>
            {this.returnList()}
          </div>
        </div>
        <div className={styles.selectedItem}>
          {this.returnSelectedItems()}
        </div>
        {this.state.siteWithoutRequiredPermissions &&
          <div className={styles["selectedItem-text"]}>
            <span style={{ color: "#c50f1f" }}>{new LocalizationService().strings.ContentOrganizer_notRequiredPermissionsOnSelectedSite}:</span>
            <span style={{ marginLeft: "5px", fontWeight: "bold" }}>{this.state.siteWithoutRequiredPermissions.text}</span>
          </div>
        }
      </div>
    )
  }
}
